import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface LoginRow { readonly id: string; readonly username: string; readonly at: string; readonly success: boolean; readonly ip: string; }

export function LoginAuditPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [rows, setRows] = useState<LoginRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ items: LoginRow[] }>('/v1/audit/logins', { token })
      .then((r) => { if (alive) setRows(r.items); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('audit.login.loading')}</p>;
  return (
    <main aria-label="login-audit">
      <h1>{t('audit.login.title')}</h1>
      <table aria-label="login-table">
        <thead><tr><th>{t('audit.login.col.when')}</th><th>{t('audit.login.col.user')}</th><th>{t('audit.login.col.ip')}</th><th>{t('audit.login.col.result')}</th></tr></thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id}>
              <td>{r.at}</td><td>{r.username}</td><td>{r.ip}</td>
              <td>{r.success ? t('audit.login.success') : t('audit.login.failed')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
